/**
 * LoadingScreen 스타일
 */

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-height: 120px;
  color: var(--color-text-secondary, var(--color-neutral-650));
}

.spinner {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  border: 3px solid var(--color-border-primary, var(--color-bg-500));
  border-top-color: var(--color-brand-primary, var(--color-brand-primary));
  animation: spin 0.9s linear infinite;
}

.label {
  margin: 0;
  font-family: 'Pretendard', sans-serif;
  font-size: var(--font-size-14, 14px);
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
